<template>
  <div class="flex flex-col min-h-screen bg-gray-100">
    <main class="flex-grow flex flex-col items-center p-6">
      <LogoBig />

      <article class="w-full max-w-3xl text-left text-gray-700">
        <h1 class="text-2xl font-bold text-gray-800 mb-6">
          {{ termsTitle }}
        </h1>
        <div
          class="prose prose-gray max-w-none"
          v-html="termsContent"
        />
      </article>
    </main>
    <MedeaFooter />
  </div>
</template>

<script>
import LogoBig from '@/components/LogoBig.vue';
import MedeaFooter from './MedeaFooter.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export default {
  name: 'TermsAndConditions',
  components: {
    LogoBig,
    MedeaFooter,
  },
  setup() {
    const { t, te, locale, messages } = useI18n();
    const route = useRoute();
    
    // Detect test type from query parameters
    const testType = computed(() => {
      return route.query.type || 'phq9'; // Default to phq9 if not specified
    });
    
    // Get the raw translation directly from messages to avoid message compiler issues
    const termsContent = computed(() => {
      try {
        // Determine which intro key to use based on test type
        const introKey = testType.value === 'gad7' 
          ? 'terms-page-intro-gad7' 
          : 'terms-page-intro-phq9';
        
        // Get intro and common content
        const localeMessages = messages.value[locale.value];
        if (!localeMessages) {
          return '';
        }
        
        const intro = localeMessages[introKey] || '';
        const common = localeMessages['terms-page-content-common'] || '';
        
        // Combine intro + common
        if (intro && common) {
          return intro + common;
        }
        
        // Fallback to generic terms-page-content if separate keys don't exist
        if (localeMessages['terms-page-content']) {
          return localeMessages['terms-page-content'];
        }
        
        return '';
      } catch (e) {
        console.error('Error loading terms content:', e);
        return '';
      }
    });
    
    const termsTitle = computed(() => {
      try {
        return te('terms-page-title') ? t('terms-page-title') : '';
      } catch (e) {
        return '';
      }
    });
    
    return {
      termsContent,
      termsTitle,
    };
  },
};
</script>
